/*
  src/redux/loyalty/actions.js

  Created by Justin Chang on 5/16/2017.
*/

import Cookies from 'js-cookie';
import callAPI from '../callAPI';
// import { getNextGoalAmount } from '../helpers';

// Constants
import {
  // SET_CARD_NUMBER,
  SET_CARD_AMOUNT,
  SET_BUFFER_AMOUNT,
  SET_GOAL_AMOUNT,
  // SET_LIFETIME_AMOUNT,
  SET_COUPON_EXPIRATION_DATE,
  SET_ALL_CARD_DATA,

  // FAIL_TO_SET_LOYALTY_CARD,
  // FAIL_TO_SET_ALL_CARD_DATA
} from './constants';

import { SET_USER_ID } from '../auth/constants';
import {logAmplitudeGiftCardOrder, setAmplitudeUserId} from "../../amplitude";


/*
  Return Loyalty Card Number from Cookies or -1
*/
export function getLoyaltyCardFromCookies() {
  return (dispatch, getState) => {
    var loyaltyCardNum = Cookies.get('adjoy_loyaltyCardNumber');

    if (loyaltyCardNum && loyaltyCardNum.length >= 11) {
      return loyaltyCardNum.slice(0,11);
    }

    return -1;
  }
}


/*
  Get Loyalty Card Data
  @params
    - cardNum
  @returns <Object>
    {
      data: {
        name:                <user id>
        rawPassword:         <user password>
        cardBalance:         <coupon balance>
        couponBufferBalance: <buffer balance>
        lifetimeUse:         <lifetime savings>
      }
    }
*/
export function getAllCardData(userId, accountId, opts={}) {
  return (dispatch, getState) => {
    return callAPI({
      ...opts,
      method: 'GET',
      path: `/app/v1/pub/loyalty/${userId}`
    })(dispatch, getState)
    .then(res => {
      // If 404, just return result
      if (res.code === 404)
        return res;

      // Else, add loyalty card info to cookies and state
      var {
        name,
        loyaltyId,
        cardBalance,
        couponBufferBalance,
        lifetimeUse,
      } = res.data;

      // Set Cookies
      Cookies.set('adjoy_loyaltyCardNumber', loyaltyId);
      Cookies.set('adjoy_userId', name);

      // Add Card Data to Redux
      const cardAmt     = Number(cardBalance);
      const bufferAmt   = Number(couponBufferBalance) || 0;
      const goalAmount  = Number(Cookies.get('adjoy_goalAmount')) || 1; // default to lowest tier


      // Dispatch to Auth
      dispatch({
        type: SET_USER_ID,
        payload: name
      });

      // Dispatch to Loyalty
      dispatch({
        type: SET_ALL_CARD_DATA,
        payload: {
          cardNumber:     loyaltyId,
          cardAmount:     cardAmt,
          bufferAmount:   bufferAmt,
          goalAmount:     goalAmount,
          lifetimeAmount: Number(lifetimeUse)
        }
      });

      setAmplitudeUserId(loyaltyId);

      return res;
    })
    .catch(err => {
      console.log('Failed to get all Loyalty Card data from api.');
      console.log(err);
    });
  }
}


/*
  Get Current Card Balance and Buffer

  @returns <Object>
    {
      data: {
        balance: "0",
        expiration: "",
        buffer: "0",
        userId: ""
      }
    }
*/
export function getCardBalance(opts={}) {
  return (dispatch, getState) => {
    return callAPI({
      ...opts,
      method: 'GET',
      path: `/app/v1/balance`
    })(dispatch, getState)
    .then(res => {
      dispatch({
        type: SET_CARD_AMOUNT,
        payload: Number(res.data.balance)
      });
      dispatch({
        type: SET_BUFFER_AMOUNT,
        payload: Number(res.data.buffer)
      });
      dispatch({
        type: SET_COUPON_EXPIRATION_DATE,
        payload: res.data.expiration
      });
    })
    .catch(err => {
      console.log('Failed to get card balance and buffer from API.');
      console.log(err);
    });
  };
}

/*
  Set New Buffer Balance
  @params
    - bufferAmt
*/
export function addToBufferAmt(campaignId) {
  return (dispatch, getState) => {
    const campaigns = getState().campaigns;
    const c = (campaigns && Array.isArray(campaigns))
      ? campaigns.find(c => c.id === campaignId)
      : false;

    if (c && c.totalValue) {
      dispatch({
        type: SET_BUFFER_AMOUNT,
        payload: (getState().loyalty.bufferAmount || 0) + c.totalValue
      });
    }
  }
}

/*
  Set New Goal Amount
  @params
    - goalAmt
*/
export function setGoalAmount(goalAmt) {
  return (dispatch, getState) => {
    Cookies.set('adjoy_goalAmount', goalAmt);

    dispatch({
      type: SET_GOAL_AMOUNT,
      payload: goalAmt
    });
  }
}




/*
  Add coupon to loyalty card
  @params
    couponAmount <Number> : must be a multiple of 3
*/
export function requestCoupon(couponAmount) {
  return (dispatch, getState) => {
    const userId  = getState().auth.userId;

    // Validate Coupon Amount
    if (couponAmount !== 1 && couponAmount % 3 !== 0)
      throw new Error('Request Coupon - coupon amount must be 1 or a multiple of 3');
    if (couponAmount < 1 || couponAmount > 9)
      throw new Error('Request Coupon - coupon amount must be between 1 and 9, inclusive.');
    if (!userId)
      throw new Error('Request Coupon - userId is required to get coupon.');

    return callAPI({
      method: 'POST',
      path: `/pub/v1/appUser/${userId}/requestCoupon?amount=${Math.floor(couponAmount)}.0`,
      skipTimeout: false
    })(dispatch, getState)
    // Reset goal amount
    .then(() => {
      logAmplitudeGiftCardOrder(couponAmount)
      return setGoalAmount(1)(dispatch, getState)
    })
    .then(() => getCardBalance()(dispatch, getState))
    .catch((err) => {
      console.log('Request Coupon - Failed to request coupon from API.');
      console.log(err);
    });
  }
}



// WEBPACK FOOTER //
// ./src/redux/loyalty/actions.js